export function TickIcon({ className = "" }) {
  return (
    <svg
      className={className}
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.58313 12.1274L4.45562 8.99988L3.39062 10.0574L7.58313 14.2499L16.5831 5.24988L15.5256 4.19238L7.58313 12.1274Z"
        fill="currentColor"
      />
    </svg>
  );
}
